<template>
  <div>
    <v-container>
      <QuickNavigation :fileData="fileData" :routeHistory="$route" />

      <section v-if="fileData">
        <v-row>
          <v-col cols="12" md="6">
            <v-card class="rounded-xl py-4" flat>
              <div class="text-center text-h5">Loan Status</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <td style="width: 50%"></td>
                      <td style="width: 50%"></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in loanStatusItems"
                      :key="`loan-status-item-table-${index}`"
                      :class="index % 2 == 0 ? '' : 'lightgrey'"
                    >
                      <td class="font-weight-bold">
                        {{ item.displayName }}
                        <v-icon
                          v-if="item.codeValue == fileData.status.loanStatus"
                          color="warning"
                          title="Current Loan Status"
                          >mdi-star
                        </v-icon>
                      </td>
                      <td>
                        <span
                          v-if="
                            fileData.status[
                              capitalizeFirstLetter(item.reference2)
                            ]
                          "
                          >{{
                            fileData.status[
                              capitalizeFirstLetter(item.reference2)
                            ] | moment("MM/DD/YYYY")
                          }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="rounded-xl py-4" flat>
              <div class="text-center text-h5">Important Dates</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <td style="width: 50%"></td>
                      <td style="width: 50%"></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Date File Created</td>
                      <td>
                        <span v-if="fileData.dateCreated">{{
                          fileData.dateCreated | moment("MM/DD/YYYY hh:mm:ss A")
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Application Date</td>
                      <td>
                        <span v-if="fileData.status.applicationDate">{{
                          fileData.status.applicationDate | moment("MM/DD/YYYY")
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Scheduled Closing Date</td>
                      <td>
                        <span v-if="fileData.status.schedClosingDate">{{
                          fileData.status.schedClosingDate
                            | moment("MM/DD/YYYY")
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Scheduled Funding Date</td>
                      <td>
                        <span v-if="fileData.status.schedFundingDate">{{
                          fileData.status.schedFundingDate
                            | moment("MM/DD/YYYY")
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
            <br />
            <v-card class="rounded-xl py-2" flat>
              <div class="text-center text-h5">Lock Information</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <td style="width: 50%"></td>
                      <td style="width: 50%"></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Rate Locked</td>
                      <td>{{ fileData.loan.intRate | percent(3, 1) }}</td>
                    </tr>
                    <tr>
                      <td>Net Pricing</td>
                      <td>
                        <span
                          v-if="fileData.loan.buyPriceNet"
                          :class="
                            getNegativePositiveColor(
                              100 - fileData.loan.buyPriceNet
                            )
                          "
                          >{{
                            (100 - fileData.loan.buyPriceNet) | percent(3, 1)
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>Lock Days</td>
                      <td>{{ fileData.loan.lockDays }}</td>
                    </tr>
                    <tr>
                      <td>Date Locked</td>
                      <td>
                        <span v-if="fileData.loan.lockStartDate">{{
                          fileData.loan.lockStartDate | moment("MM/DD/YYYY")
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Lock Exp. Date</td>
                      <td>
                        <span v-if="fileData.loan.lockExpirationDate">{{
                          fileData.loan.lockExpirationDate
                            | moment("MM/DD/YYYY")
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Date Canceled</td>
                      <td>
                        <span v-if="fileData.loan.lockCanceledDate">{{
                          fileData.loan.lockCanceledDate | moment("MM/DD/YYYY")
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>First Payment Date</td>
                      <td>
                        <span v-if="fileData.loan.firstPaymentDate">{{
                          fileData.loan.firstPaymentDate | moment("MM/DD/YYYY")
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Closed Date/Time</td>
                      <td>
                        <span v-if="fileData.status.closedDate">{{
                          fileData.status.closedDate
                            | moment("MM/DD/YYYY hh:mm:ss A")
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <!-- <v-col cols="12">
            <v-card class="rounded-xl py-4" flat>
              <div class="text-center text-h5">Quality Assureance Status</div>
              <v-simple-table class="table--bordered" dense>
                <template v-slot:default>
                  <tbody></tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card class="rounded-xl py-4" flat>
              <div class="text-center text-h5">Disclosure History</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Form</th>
                      <th>Created</th>
                      <th>Delivered</th>
                      <th>Method</th>
                      <th>Received</th>
                      <th>Earliest Closing Date</th>
                    </tr>
                  </thead>
                  <tbody v-if="disclosureLogEntryItems.length > 0">
                    <tr
                      v-for="(item, index) in disclosureLogEntryItems"
                      :key="`disclosureLogEntryItems-table-${index}`"
                      :class="index % 2 == 0 ? 'lightgrey' : ''"
                    >
                      <td>
                        <span :class="item.form == 1 ? 'secondary--text' : 'primary--text'">
                          {{
                            $store.state.mstCodeEnums["tridForm" + item.form]
                          }}
                        </span>
                        -
                        {{
                          $store.state.mstCodeEnums[
                            "disclosureRevisionType" +
                              item.disclosureRevisionType
                          ]
                        }}
                      </td>
                      <td>
                        <div v-if="item.issuedDate">
                          {{
                            item.issuedDate | moment("MM/DD/YYYY")
                          }}
                        </div>
                      </td>
                      <td>
                        <div v-if="item.deliveryDateAndTime">
                          {{
                            item.deliveryDateAndTime
                              | moment("MM/DD/YYYY hh:mm:ss A")
                          }}
                        </div>
                      </td>
                      <td>
                        <div v-if="item.deliveryMethod > 0">
                          {{
                            $store.state.mstCodeEnums[
                              "gfeDeliveryMethod" + item.deliveryMethod
                            ]
                          }}
                        </div>
                      </td>
                      <td>
                        <div v-if="item.receivedDate">
                          {{ item.receivedDate | moment("MM/DD/YYYY") }}
                        </div>
                      </td>
                      <td>
                        <div v-if="item.earliestClosingDate">
                          {{
                            item.earliestClosingDate
                              | moment("MM/DD/YYYY")
                          }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="6" class="error--text text-center">No Data</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col> -->
        </v-row>
      </section>

      <LoanDetailSubMenu />
    </v-container>
  </div>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";
import { convert } from "@/mixins";

export default {
  name: "DateTracking",
  components: {
    QuickNavigation,
    LoanDetailSubMenu,
  },
  async mounted() {
    this.loanNumber = this.$route.query.loanNumber;

    this.fileData = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.loanNumber,
      })
      .then((resp) => resp.data)
      .catch(() => null);

    this.loanStatusItems = await this.$store
      .dispatch("mstcode/getAll", "LoanStatus")
      .then((resp) => resp.data.filter((x) => x.reference10 == "Y"))
      .catch(() => []);

    this.disclosureLogEntryItems = await this.$store
      .dispatch("disclosureLogEntry/getAll", this.fileData.fileDataId)
      .then((resp) => resp.data)
      .catch(() => []);
  },
  data() {
    return {
      fileData: null,
      loanStatusItems: [],
      disclosureLogEntryItems: [],
    };
  },
  methods: {},
  mixins: [convert],
};
</script>
